// extracted by mini-css-extract-plugin
module.exports = {"root":"ActivityContainer_root__deulV"};